// ─── LOGO ─────────────────────────────────────────────────────────────────────
function CXOEraLogo({ height = 36, onClick }) {
  return (
    <svg onClick={onClick} height={height} viewBox="0 0 210 48" fill="none"
      style={{ cursor: onClick ? "pointer" : "default", display: "block", flexShrink: 0 }}>
      <text x="0" y="38" fontFamily="'Cormorant Garamond',Georgia,serif" fontSize="46" fontWeight="600" fill="#C9A96E" letterSpacing="-1">C</text>
      <text x="28" y="38" fontFamily="'Cormorant Garamond',Georgia,serif" fontSize="46" fontWeight="300" fontStyle="italic" fill="#ffffff" letterSpacing="-1">X</text>
      <text x="55" y="38" fontFamily="'Cormorant Garamond',Georgia,serif" fontSize="46" fontWeight="600" fill="#C9A96E" letterSpacing="-1">O</text>
      <circle cx="91" cy="30" r="3" fill="#C9A96E" opacity="0.6"/>
      <text x="99" y="38" fontFamily="'Cormorant Garamond',Georgia,serif" fontSize="38" fontWeight="300" fontStyle="italic" fill="#ffffff" opacity="0.9">Era</text>
    </svg>
  );
}

export default CXOEraLogo;
